__turbopack_context__.v({
  "container": "Section-module__JFfFJW__container",
  "header": "Section-module__JFfFJW__header",
  "infoButton": "Section-module__JFfFJW__infoButton",
  "titles": "Section-module__JFfFJW__titles",
});
